import React from 'react';
import DashboardContainer from '../components/dashboard/DashboardContainer';

const Dashboard = () => (
  <DashboardContainer />
);

export default Dashboard;
